import PageDataLoader from '../../../lib/page-data/loader';
import PageKey from '../../../lib/page-data/key';
import {
  TEAM_SQUAD_PAGE_REQUEST,
  TEAM_SQUAD_PAGE_RECEIVE,
  TEAM_SQUAD_PAGE_FAILURE,
  TEAM_PROFILE_PAGE_REQUEST,
  TEAM_PROFILE_PAGE_RECEIVE,
  TEAM_PROFILE_PAGE_FAILURE,
  PAGE_DATA_LOAD,
  SELECT_SEASON,
} from '../../action-types';

export const fetchPageData = (clubId, teamId, request) => async (dispatch) => {
  try {
    dispatch({ type: TEAM_SQUAD_PAGE_REQUEST, payload: { clubId, teamId } });
    const pageKey = new PageKey(clubId, 'squad', { teamId });
    const pageData = await PageDataLoader.getPageData(pageKey, request);
    const { staff_and_coaches: staffAndCoaches, players } = pageData.data;
    dispatch({
      type: TEAM_SQUAD_PAGE_RECEIVE,
      payload: { clubId, teamId, staffAndCoaches, players },
    });
    dispatch({ type: PAGE_DATA_LOAD, payload: pageKey.toString() });
    return {};
  } catch (error) {
    let statusCode = 500;
    if (error) {
      statusCode = error.errorStatusCode || statusCode;
    }
    dispatch({
      type: TEAM_SQUAD_PAGE_FAILURE,
      payload: { clubId, teamId, statusCode, error },
    });

    return { error };
  }
};

export const fetchProfilePageData =
  (clubId, teamId, profileId, seasonId = null, request) =>
  async (dispatch) => {
    try {
      dispatch({ type: SELECT_SEASON, payload: seasonId });
      dispatch({
        type: TEAM_PROFILE_PAGE_REQUEST,
        payload: { clubId, teamId, profileId, seasonId },
      });
      const pageKey = new PageKey(clubId, 'profile', { teamId, profileId, seasonId });
      const pageData = await PageDataLoader.getPageData(pageKey, request);

      dispatch({
        type: TEAM_PROFILE_PAGE_RECEIVE,
        payload: {
          clubId,
          teamId,
          profileId,
          seasonId,
          data: {
            id: `${teamId}-${profileId}-${seasonId}`,
            ...pageData.data,
          },
        },
      });
      dispatch({ type: PAGE_DATA_LOAD, payload: pageKey.toString() });

      return {};
    } catch (error) {
      let statusCode = 500;
      if (error) {
        statusCode = error.errorStatusCode || statusCode;
      }
      dispatch({
        type: TEAM_PROFILE_PAGE_FAILURE,
        payload: {
          id: `${teamId}-${profileId}-${seasonId}`,
          clubId,
          teamId,
          profileId,
          seasonId,
          statusCode,
          error,
        },
      });
      return { error };
    }
  };
